import React from 'react';
import { Model } from '../interfaces/Model';
import styles from './File.module.css';

type Props = {
  fileNumber: string
  model: Model | null
}

export default function File ({
  fileNumber,
  model
}: Props): React.ReactElement {

  const displayImage = () => {
    if (model && model.imageUrl) {
      return (
        <img src={ model.imageUrl }
          alt={ model.name }
          className={ styles.imageModel }
          loading="lazy"/>
      );
    }
    return (
      <span className={ `icon is-huge ${ styles.imagePlaceholder }` }>
        <i className={ `tri-mobile ${ styles.imagePlaceholderIcon }` }
          aria-hidden="true"></i>
      </span>
    );
  };

  return (
    <div className="box">
      <div className="rows">
        <div className="row">
          <div className="columns is-mobile">
            <div className="column is-4 has-text-centered">
              { displayImage() }
            </div>
            <div className="column">
              <p className="text is-size-5 has-text-weight-semibold">Dossier</p>
              <p className="text is-level-1">{ fileNumber }</p>
              <p className="text is-size-5 has-text-weight-semibold">Modèle</p>
              { model &&
                <p className="text is-level-1 is-marginless">{ model.name }</p>
              }
              { !model &&
                <p className="text is-level-1 is-marginless">Modèle inconnu</p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}